<div>
        <div id="operaciones-list-container2">
            <div class="row table-header">
                <div class="mobile-hidden column vehicle">
                    <span>ASEGURADO</span>
                </div>
                <div class="mobile-hidden column coverage state-column">
                    <span>PRODUCTO</span>
                </div>
                <div class="mobile-hidden column state">
                    <span>ESTADO</span>
                </div>
                <div class="mobile-hidden column button">
                </div>
                <div class="desktop-hidden column">
                    <span>INFORMACIÓN</span>
                </div>
            </div>
            <ng-container *ngIf="operations && operations.length">
                <div *ngFor="let operation of operations; let i = index;" class="table-body row operacion-row">
                    <!-- Riesgo -->
                    <div class="mobile-hidden column vehicle elipsis" id="{{'operacion-list-vehicle-' + i}}">
                        <span class="insured-name">{{getName(operation) | truncate : 25 | titlecase}}</span>
                        <span class="risk-label">
                            {{operation.vehicleSummaryDTO[0].brand + ' ' + operation.vehicleSummaryDTO[0].model + ' ' + operation.vehicleSummaryDTO[0].ext_VersionDesc  ||"---"}}
                        </span>
                        <span class="pas" *ngIf="operation.vehicleSummaryDTO[0].licensePlate">{{operation.vehicleSummaryDTO[0].licensePlate}}</span>
                    </div>
                    <!-- Cobertura -->
                    <div class="mobile-hidden column state-column" id="{{'operacion-list-product-' + i}}">
                        <div class="centered">
                            <div class="coverage-label" *ngIf="operation.vehicleSummaryDTO[0].productOfferingName">{{ operation.vehicleSummaryDTO[0].productOfferingName }}</div>
                            <span class="coverage-branch">
                                Automotor
                            </span>
                        </div>
                    </div>
                    <!-- Estado -->
                    <div class="mobile-hidden column state" id="{{'operacion-list-state-' + i}}">
                        <span class="state-pin" [ngClass]="'VISUALIZA_1' | scPolicyStep:'color':'':'P'"></span>
                        <span class="state-title">
                            Póliza: {{operation.policyNumberComplete}}
                        </span>
                    </div>
                    <!-- Botones desktop -->
                    <div class="mobile-hidden column button" id="{{'operacion-list-button-' + i}}">
                        <sc-button 
                            [id]="'impresiones_planes'" 
                            type="secondary"
                            (onClick)="openModal(operation)">
                            Descargar
                        </sc-button>
                    </div>
                    <!-- MOBILE -->
                    <div class="mobile-column desktop-hidden" id="{{'operacion-list-information-' + i}}">
                        <div class="state">
                            <span class="state-pin" [ngClass]="'VISUALIZA_1' | scPolicyStep:'color':'':'P'"></span>
                        </div>
                        <div class="info">
                            <span class="mobile-line insured-name">{{getName(operation) | truncate : 31 | titlecase }}</span>
                            <span class="mobile-line risk-label">
                                {{operation.vehicleSummaryDTO[0].brand + ' ' + operation.vehicleSummaryDTO[0].model + ' ' + operation.vehicleSummaryDTO[0].ext_VersionDesc||"---" | truncate : 41}}
                            </span>
                            <span class="mobile-line risk-label">
                                {{operation.vehicleSummaryDTO[0].licensePlate}}
                            </span>
                            <span class="mobile-line merged-column">
                                <span class="coverage-label-line" *ngIf="operation.vehicleSummaryDTO[0].productOfferingName">
                                    {{ operation.vehicleSummaryDTO[0].productOfferingName }}
                                </span>
                            </span>
                            <span class="mobile-line state-title">
                                Póliza: {{operation.policyNumberComplete}}
                            </span>
                        </div>
                        <div class="button-centered">
                            <sc-button 
                                [id]="'impresiones_planes'" 
                                type="secondary"
                                prefixIcon="download" 
                                [iconOnly]="true"
                                (onClick)="openModal(operation)">
                                Imprimir
                            </sc-button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div id="operaciones-list-container" *ngIf="(!operations || !operations.length)" class="row operaciones-list__empty-message">
            <div class="col-md-12 col-xs-12 operaciones-list__empty-message-content">
                <div>
                    <img src="assets/images/planes/emptyResults.png" alt="sin resultado">
                </div>
                <div>
                    <h5 class="operaciones-list__message">No hay resultados de búsqueda coincidentes</h5>
                </div>
                <div>
                    <p class="operaciones-list__message_description">Puede que hayas escrito mal el DNI/CUIT de tu
                        cliente.<br> Intentá de nuevo</p>
                </div>
            </div>
        </div>
    </div>

    <sc-modal title="Titulo modal 1" #modalDescargas>
        <sc-auto-plan-downloads
            [policyData]="policyData">

        </sc-auto-plan-downloads>
    </sc-modal>
